<template>
  <div>
    <div class="weui-footer_fixed-bottom download">
      <img @click="click" class="download-icon" src="../assets/Shake_Phone_Filled_100.png">
    </div>

    <we-reactive-dialog
      v-bind:is-show-dialog="isShowDownloadDialog"
      v-on:secondOnClick="cancelDownload"
      v-on:mainOnClick="doDownload">
      <div slot="title">下载APP</div>
      <div slot="content">发现更多功能，请下载易退税APP</div>
      <div slot="main-operation">去下载</div>
      <div slot="secondly-operation">取消</div>
    </we-reactive-dialog>
  </div>
</template>

<style lang="stylus">
  .download
    bottom 60px
    right 0px
    text-align right
  .download-icon
    width 60px
    margin-right 24px
</style>

<script>
  import WeReactiveDialog from '../components/WeReactiveDialog'

  export default{
    data () {
      return {
        isShowDownloadDialog: false
      }
    },

    methods: {
      click () {
        this.$emit('click')
        this.isShowDownloadDialog = true
      },

      cancelDownload () {
        this.isShowDownloadDialog = false
      },

      doDownload () {
        window.location = 'https://www.yituishui.com/application/download'
      }
    },

    components: {
      WeReactiveDialog
    }
  }
</script>



// WEBPACK FOOTER //
// DownloadApp.vue?3e5b59e4